import { IABExperiment } from '@cian/api-models/monolith-python/cian-api/site/v1/get-ab-experiments';
import { Popup, PopupArrow } from '@cian/popup-component';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { ReliableIcon } from '../../../common/components/reliable_icon';
import { IOfferHelper } from '../../../presenter';
import { IOffer } from '../../../types/offer';
import { IJKNameTracking } from './tracking';

import * as styles from './index.css';

const reliableIcon = (href: string) => (
  <div className={styles['reliable-wrapper']}>
    <ReliableIcon className={styles['reliable-icon']} />

    <Popup arrow={PopupArrow.LEFT} containerStyle={styles['popup']}>
      <div>
        <ReliableIcon className={styles['icon']} />
      </div>
      <strong className={styles['title']}>Проверено ЦИАН</strong>
      <p>
        В ЖК есть корпуса, проверенные ЦИАН.
      </p>
      <a href={`${href}#reliable`} className={styles['link']} target="_blank">Узнать подробнее</a>
    </Popup>
  </div>
);

export interface IJkNameContext {
  experiments: IABExperiment[];
  offer: IOffer;
  offerHelper: IOfferHelper;
  tracking?: {
    trackJKLinkClicked?: IJKNameTracking['trackJKLinkClicked'];
  };
}

export class JkName extends React.Component {
  public context: IJkNameContext;

  public static contextTypes = {
    experiments: PropTypes.array,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public render() {
    const offer = this.context.offerHelper;

    if (offer.isRent()) {
      return null;
    }

    const { geo, newbuilding } = this.context.offer;
    const isReliable =  newbuilding && newbuilding.showJkReliableFlag;

    if (geo && geo.jk && geo.jk.displayName) {
      const { fullUrl } = geo.jk;

      return (
        <div className={styles['container']}>
          {!fullUrl && geo.jk.displayName}
          {
            fullUrl &&
              // 19px - ширина иконки "Надежный выбор"
              <div style={{ marginLeft: isReliable ? 19 : 0 }}>
                {isReliable && reliableIcon(fullUrl)}

                <a
                  href={fullUrl}
                  className={styles['building-link']}
                  target="_blank"
                  onClick={this.handleNameLinkClick}
                >
                  {geo.jk.displayName}
                </a>
              </div>
          }
        </div>
      );
    }

    return (
      <div></div>
    );
  }

  private handleNameLinkClick = () => {
    const { offer, tracking } = this.context;

    if (tracking && tracking.trackJKLinkClicked) {
      tracking.trackJKLinkClicked(offer);
    }
  }
}
